import * as types from './types'
import * as UserState from './state'
import {STORAGE_KEY} from '../../state'
import moment from 'moment'

const clearState = (oldState, newState) => {
	if (oldState !== null && oldState !== undefined) {
		Object.keys(oldState).forEach((key) => {
			if (typeof oldState[key] === 'object') {
				if (oldState[key] instanceof Array) {
					oldState[key] = []
				} else {
					oldState[key] = clearState(oldState[key], newState[key])
				}
			} else {
				oldState[key] = newState[key]
			}
		})
	}
	return oldState
}

const roleComputer = (roles) => {
	if (roles.indexOf('ROLE_ANONYMOUS') !== -1) {
		return 'ANONYMOUS'
	} else if (roles.indexOf('ROLE_ADVISOR') !== -1) {
		return 'ADVISOR'
	} else {
		return 'CLIENT'
	}
}

export const mutations = {
	[types.LOGIN] (state, data) {
		state.token = data.token
		state.refresh = data.refresh_token
		state.id = data.user.id
		state.role = roleComputer(data.user.roles)
		state.available = data.user.available
		state.ooo_message = data.user.ooo_message

		state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
	},
	[types.TOKEN] (state, data) {
		state.token = data.user.token
		state.refresh = data.user.refresh_token

		state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
	},
	[types.LOGOUT] (state) {
		clearState(state, UserState.default)
		state.token = null
		window.localStorage.removeItem(STORAGE_KEY)
	},
	[types.UPDATE_PROFILE]  (state, data) {
		state.firstname = data.firstname
		state.lastname = data.lastname
		state.email = data.email
		state.address = {
			line: data.address.line,
			zip: data.address.zip,
			city: data.address.city,
			country: data.address.country
		}
		state.phone = data.phone
	},
	[types.PROFIL_PICTURE] (state, data) {
		state.picture = data.image
	},
	[types.GET_CLIENTS] (state, data) {
		state.clients = data
	},
	[types.UPDATE_CLIENT] (state, data) {
		if (!data) {
			return
		}
		// On purge les éventuelles entrées nulles (état persisté corrompu)
		const clients = (state.clients || []).filter(client => client)
		const index = clients.findIndex(client => parseInt(client.id) === parseInt(data.id))
		if (index === -1) {
			// Client absent du store (accès direct par URL / rechargement) : on l'ajoute
			clients.push(data)
		} else {
			clients[index] = data
		}
		state.clients = clients
	},
	[types.ADD_CLIENT] (state, data) {
		state.clients.push(data)
	},
	[types.EDIT_CLIENT] (state, data) {
		state.clients.forEach((client, key) => {
			if (client.id === data.id) {
				const c = state.clients[key]
				c.center_of_interest = data.centerOfInterests
				c.email = data.email
				c.firstname = data.firstname
				c.phone = data.phone
				c.lastname = data.lastname
				c.type = data.type
			}
		})

		state.clients = state.clients.slice()
	},
	[types.ADD_NOTE] (state, data) {
		let note = data.note
		state.clients.filter(client => (parseInt(client.id) === parseInt(data.id)))[0].notes.push(note)
	},
	[types.UPDATE_NOTE] (state, data) {
		const note = state.clients.filter(client => (parseInt(client.id) === parseInt(data.id)))[0].notes.filter(note => (parseInt(note.id) === parseInt(data.note.id)))[0]
		note.title = data.note.title
		note.description = data.note.description
	},
	[types.DELETE_NOTE] (state, data) {
		const client = state.clients.filter(client => (parseInt(client.id) === parseInt(data.clientId)))[0]
		const note = client.notes.filter(note => (parseInt(note.id) === parseInt(data.note.id)))[0]
		client.notes.splice(client.notes.indexOf(note), 1)
	},
	[types.FILL_ESTATE] () {
		// do nothing (client side case)
	},
	[types.ADD_LCBCFT_TO_CLIENT] (state, data) {
		state.clients.forEach((client) => {
			if (parseInt(client.id) === parseInt(data)) {
				client.lcbft_completed = true
			}
		})

		state.clients = state.clients.slice()
	},
	[types.ADD_CHECK_PAYSAGE] (state, data) {
		state.clients.forEach((client) => {
			if (parseInt(client.id) === parseInt(data)) {
				// Marquer que le check paysage a été effectué
				client.check_paysage_completed = true
			}
		})
		state.clients = state.clients.slice()
	},
	[types.SET_AVAILABLE] (state, data) {
		state.available = data.available
		state.ooo_message = data.ooo_message
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/mutations.js